import React from 'react';
import { twMerge } from 'tailwind-merge';
interface SectionHeaderProps {
  title: React.ReactNode;
  body?: React.ReactNode;
  align?: 'left' | 'center';
  as?: 'h1' | 'h2';
  className?: string;
}
export function SectionHeader({
  title,
  body,
  align = 'left',
  as = 'h2',
  className
}: SectionHeaderProps) {
  const Heading = as;
  return <div className={twMerge(align === 'center' ? 'mx-auto max-w-2xl text-center' : 'max-w-2xl', className)} data-id="element-477" data-mp="27h6l9ghwrqrz">
      <Heading className={twMerge('text-balance font-semibold tracking-display text-ink', as === 'h1' ? 'text-4xl sm:text-5xl md:text-6xl' : 'text-3xl sm:text-4xl md:text-[44px] md:leading-[1.08]')} data-id="element-478" data-mp="2v4eoztzourrw">
        {title}
      </Heading>
      {body ? <div className="mt-5 text-lg leading-relaxed text-ink-soft" data-id="element-479" data-mp="2q5tr417wsk6m">{body}</div> : null}
    </div>;
}